module.exports = __webpack_public_path__ + "img/cat-logo.0d402d5f.jpg";